/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Rest_Live_TitleInputs */

const en_us2_native_release_rest_live_title = /** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resting`)
};

const pt_br2_native_release_rest_live_title = /** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansando`)
};

const pt_pt2_native_release_rest_live_title = /** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansando`)
};

/** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */
const es_419_native_release_rest_live_title = en_us2_native_release_rest_live_title;

/** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */
const fr_fr2_native_release_rest_live_title = en_us2_native_release_rest_live_title;

/** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */
const de_de2_native_release_rest_live_title = en_us2_native_release_rest_live_title;

/** @type {(inputs: Native_Release_Rest_Live_TitleInputs) => LocalizedString} */
const it_it2_native_release_rest_live_title = en_us2_native_release_rest_live_title;

/**
* | output |
* | --- |
* | "Resting" |
*
* @param {Native_Release_Rest_Live_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_rest_live_title = /** @type {((inputs?: Native_Release_Rest_Live_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Rest_Live_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_rest_live_title(inputs)
	if (locale === "es-419") return es_419_native_release_rest_live_title(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_rest_live_title(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_rest_live_title(inputs)
	if (locale === "de-DE") return de_de2_native_release_rest_live_title(inputs)
	if (locale === "it-IT") return it_it2_native_release_rest_live_title(inputs)
	return en_us2_native_release_rest_live_title(inputs)
});
export { native_release_rest_live_title as "native-release.rest_live_title" }